let intervalId;
let timeoutId;
let resizeHandler;

export function initializeHeroTaglines() {
    const container = document.querySelector('.hero__taglines');
    if (!container) return;

    resizeHandler = function() {
        if (container) {
            const first = container.querySelector('div');
            if (first) {
                container.style.setProperty('--tagline-height', first.offsetHeight + 'px');
            }
        }
    };

    // Initial calculation
    resizeHandler();

    window.addEventListener('resize', resizeHandler);
    window.addEventListener('orientationchange', resizeHandler);

    intervalId = setInterval(function() {
        container.classList.add('moving');

        timeoutId = setTimeout(function() {
            container.classList.remove('moving');
            const last = container.lastElementChild;
            const active = container.querySelector('.active');
            
            if (last) {
                container.insertBefore(last, container.firstElementChild);
            }
            
            if (active) {
                active.classList.remove('active');
                if (active.previousElementSibling) {
                    active.previousElementSibling.classList.add('active');
                } else if (container.lastElementChild) {
                    container.lastElementChild.classList.add('active');
                }
            }
        }, 1000);
    }, 3000);
}

export function destroyHeroTaglines() {
    if (intervalId) clearInterval(intervalId);
    if (timeoutId) clearTimeout(timeoutId);
    if (resizeHandler) {
        window.removeEventListener('resize', resizeHandler);
        window.removeEventListener('orientationchange', resizeHandler);
    }
}